export enum ButtonSizeEnum {
  DEFAULT = "",
  SMALL = "mp-btn-small",
  LARGE= "mp-btn-large"
}
